import { Table, Tag, Button, Popover, message } from "antd";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import type { ColumnsType } from "antd/es/table";
import { UseMutateAsyncFunction, useMutation, useQuery } from "react-query";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { deleteItems, getItemsByCategory } from "../../api/itemapi";
import EditButton from "../UI/EditButton/editbutton";
import { DatabaseOutlined } from "@ant-design/icons";
import DeleteButton from "../UI/DeleteButton/deletebutton";
import DeleteModal from "../UI/ModalComponent/DeleteModal/deletemodal";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import { getItemsById } from "../../api/itemapi";
import { getCategoryDrpdown } from "../../api/category";
import { getSupplierDropdown } from "../../api/supplier";
import { getItemUnitDropdown } from "../../api/itemUnit";
import { getBrandDropdown } from "../../api/brand";
import { getPriceSchemeDropdown } from "../../api/pricescheme";
import CookieIcon from "@mui/icons-material/Cookie";
import { AxiosResponse } from "axios";
import { PackagingModal } from "./PackagingModal";
import { ComponentModal } from "./ComponentModal";
import PrintButton from "../UI/PrintButton/printbutton";
import JsBarcode from "jsbarcode";
interface inventoryProps {
  ItemsMutation: UseMutateAsyncFunction<
    AxiosResponse<any, any>,
    unknown,
    {
      limit: number;
      q: string;
      isActive?: boolean | undefined;
      isChild: boolean;
    },
    unknown
  >;
  isItemsLoading: boolean;
  page: number;
  setPage: Dispatch<SetStateAction<number>>;
  filter: boolean | undefined;
  search: string;
  paginatedItems: any;
  setPaginatedItems: Dispatch<any>;
  selectedCategory: null;
  tableKey: string;
}

interface ItemsInterface {
  id: string;
  name: string;
  description: string;
  isActive: boolean;
  minInStock: number;
  supplier: string;
}

const InventoryList = ({
  ItemsMutation,
  isItemsLoading,
  page,
  setPage,
  filter,
  search,
  paginatedItems,
  setPaginatedItems,
  selectedCategory,
  tableKey,
}: inventoryProps) => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [idToDelete, setIdToDelete] = useState<string | undefined>(undefined);
  const [nameToDelete, setNameToDelete] = useState<any>();
  const [formatedcategory, setFormatedcategory] = useState<{}[]>();
  const [formatedItemUnit, setFormatedItemUnit] = useState<{}[]>();
  const [formatedBrand, setFormatedBrand] = useState<{}[]>();
  const [formatedSupplier, setFormatedSupplier] = useState<{}[]>();
  const [formatedPriceScheme, setFormatedPriceScheme] = useState<{}[]>();
  const [, setError] = useState("");
  const [prevPage, setPrevPage] = useState<number>(0);
  const [maxPage, setMaxPage] = useState<number>(0);
  const [t] = useTranslation("common");
  const modifier = <div>{t("modifiers")}</div>;
  const [openPackaging, setOpenPackaging] = useState(false);
  const [openComponent, setOpenComponent] = useState(false);
  const [selectedItemId, setSelectedItemId] = useState<any>(null);
  const [isPacking, setIsPacking] = useState(false);
  const [isComposed, setIsComposed] = useState(false);
  const content = (record: any) => {
    return (
      <div>
        {record.isPacking ? `${t("packaging-on")}` : `${t("packaging-off")}`}
      </div>
    );
  };
  const component = (record: any) => {
    return (
      <div>
        {record.isComposed ? `${t("component-on")}` : `${t("component-off")}`}
      </div>
    );
  };

  useEffect(() => {
    page > prevPage &&
      maxPage < page &&
      ItemsMutation({
        limit: page * 10 + 10,
        q: search,
        isActive: filter,
        isChild: false,
      }).then((res) => {
        if (page > maxPage) setMaxPage(page);
        setPaginatedItems(res.data?.data);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, filter]);

  const HandlePrintBarcode = (barcode: string, name: string) => {
    try {
      const printWindow = window.open("", "_blank");

      if (!printWindow) {
        console.error("Error opening print window");
        return;
      }
      const svgNS = "http://www.w3.org/2000/svg";
      const svg = document.createElementNS(svgNS, "svg");
      svg.setAttribute("width", "100");
      svg.setAttribute("height", "50");

      JsBarcode(svg, barcode, {
        format: "EAN13",
        displayValue: true,
        width: 1,
        height: 15,
        margin: 0,
        textMargin: -2,
      });

      const customHTML = `
      <body style="margin: 0.2rem 0 0 0.3rem">
      <div style="width: fit-content">
        <h6 style="   
          margin: 0;
          padding: 0;
          margin-bottom: .1rem;
          font-size: 8px;
          font-family: Arial;
          font-weight: bold;
          text-transform: uppercase;
          text-align: center
          ">
          ${name}
          </h6>
        ${svg.outerHTML}
      </div>
      </body>
    `;

      const printDocument = printWindow.document;
      printDocument.open();
      printDocument.write(customHTML);
      printDocument.close();

      printWindow.print();
    } catch (error: any) {
      message.error(error)
    }
  };

  const deleteItemsMutation = useMutation("deleteItems", deleteItems, {
    onSuccess: () => {
      ItemsMutation({
        limit: page * 10 + 10,
        q: search,
        isActive: filter,
        isChild: false,
      }).then((res: any) => {
        setPaginatedItems(res.data?.data);
        message.success("Complete successfully");
      });
    },
    onError: (error: any, context: unknown) => {
      if (setError) {
        setError(error.response.data.message);
        message.error(error.response.data.message);
      } else {
        message.error("");
      }
    },
  });

  const DeleteItem = (id: string | undefined, name: string): void => {
    setOpen(true);
    setIdToDelete(id);
    setNameToDelete(name);
  };

  const handleOk = () => {
    if (idToDelete) {
      deleteItemsMutation.mutate({ id: idToDelete });
    }
    setOpen(false);
  };

  const { isLoading: loadingcategory } = useQuery(
    "categories",
    getCategoryDrpdown,
    {
      refetchOnWindowFocus: false,
      onSuccess: (res) => {
        setFormatedcategory(
          res.data.map((category: any) => {
            return {
              value: category.id,
              label: category.name,
            };
          })
        );
      },
    }
  );

  const { isLoading: loadingItemUnit } = useQuery(
    "ItemUnit",
    getItemUnitDropdown,
    {
      refetchOnWindowFocus: false,
      onSuccess: (res) => {
        setFormatedItemUnit(
          res.data?.map((unit: any) => {
            return { value: unit.id, label: unit.name };
          })
        );
      },
    }
  );

  const { isLoading: loadingBrand } = useQuery("brands", getBrandDropdown, {
    refetchOnWindowFocus: false,
    onSuccess: (res) => {
      setFormatedBrand(
        res.data.map((brand: any) => {
          return { value: brand.id, label: brand.name };
        })
      );
    },
  });

  const { isLoading: loadingSupplier } = useQuery(
    "suppliers",
    getSupplierDropdown,
    {
      refetchOnWindowFocus: false,
      onSuccess: (res) => {
        setFormatedSupplier(
          res.data.map((supplier: any) => {
            return { value: supplier.id, label: supplier.name };
          })
        );
      },
    }
  );

  const { isLoading: loadingPriceScheme } = useQuery(
    "PriceScheme",
    getPriceSchemeDropdown,
    {
      refetchOnWindowFocus: false,
      onSuccess: (res) => {
        setFormatedPriceScheme(
          res.data.map((price: any) => {
            return { value: price.id, label: price.name };
          })
        );
      },
    }
  );

  const getItemsMutation = useMutation("getItems", getItemsById);
  function fillItemById(id: any, key: string) {
    getItemsMutation.mutateAsync(id).then((res) => {
      navigate(`/item/${id}`, {
        state: {
          item: res.data,
          formatedBrand: formatedBrand,
          loadingBrand: loadingBrand,
          formatedItemUnit: formatedItemUnit,
          loadingItemUnit: loadingItemUnit,
          formatedPriceScheme: formatedPriceScheme,
          loadingPriceScheme: loadingPriceScheme,
          formatedSupplier: formatedSupplier,
          loadingSupplier: loadingSupplier,
          formatedcategory: formatedcategory,
          loadingcategory: loadingcategory,
          key: key,
        },
      });
    });
  }

  const [filteredItems, setFilteredItems] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (selectedCategory) {
          const response = await getItemsByCategory(selectedCategory);
          setFilteredItems(response.data.data);
        } else {
          setFilteredItems(paginatedItems);
        }
      } catch (error) {
        console.error("Error fetching items:", error);
      }
    };

    fetchData();
  }, [paginatedItems, selectedCategory]);
  const [isModifier, setIsModifier] = useState(false);

  const columns: ColumnsType<ItemsInterface> = [
    {
      title: `${t("category")}`,
      dataIndex: "category",
      key: "category",
      width: "10rem",
      render: (record: any) => {
        return record ? record.name : null;
      },
    },
    {
      title: `${t("name")}`,
      dataIndex: "name",
      key: "name",
      className: "table-header",
      align: "center",
    },
    {
      title: `${t("supplier")}`,
      dataIndex: "supplier",
      key: "supplier",
      width: "14rem",
      align: "center",
      render: (record: any) => {
        return record ? record.name : null;
      },
    },
    {
      title: `${t("barcode")}`,
      dataIndex: "barcode",
      key: "barcode",
      width: "9rem",
      align: "center",
    },
    {
      title: `${t("status")}`,
      dataIndex: "isActive",
      key: "isActive",
      width: "5rem",
      align: "center",
      render: (record: any) =>
        record ? (
          <Tag className="active">Active</Tag>
        ) : (
          <Tag className="inactive">Inactive</Tag>
        ),
    },
    {
      title: `${t("action")}`,
      key: "action",
      width: "14rem",
      align: "center",
      render: (record: any) => (
        <>
          <PrintButton
            onClick={() =>
              HandlePrintBarcode(
                record.barcode,
                record.name.toString().substring(0, 22)
              )
            }
          />
          <Popover content={modifier} mouseEnterDelay={0} mouseLeaveDelay={0}>
            <Button
              className="Button"
              type="text"
              icon={
                <CookieIcon style={{ fontSize: "14px", color: "#212121" }} />
              }
              onClick={() => {
                if (!isModifier) {
                  setIsModifier(true);
                  fillItemById(record.id, "5");
                }
              }}
              disabled={isModifier}
            />
          </Popover>
          <Popover
            content={content(record)}
            mouseEnterDelay={0}
            mouseLeaveDelay={0}
          >
            <Button
              icon={
                <Inventory2Icon
                  style={{
                    fontSize: "14px",
                    color: record.isPacking ? "green" : "red",
                  }}
                />
              }
              className="Button"
              type="text"
              onClick={() => {
                setSelectedItemId(record.id);
                setIsPacking(record.isPacking);
                setOpenPackaging(true);
              }}
            ></Button>
          </Popover>
          <Popover
            content={component(record)}
            mouseEnterDelay={0}
            mouseLeaveDelay={0}
          >
            <Button
              className="Button"
              icon={
                <DatabaseOutlined
                  style={{
                    fontSize: "14px",
                    color: record.isComposed ? "green" : "red",
                  }}
                />
              }
              type="text"
              onClick={() => {
                setSelectedItemId(record.id);
                setOpenComponent(true);
                setIsComposed(record.isComposed);
              }}
            />
          </Popover>
          <EditButton onClick={() => fillItemById(record.id, "1")} />
          <DeleteButton disabled={!record.canDelete} onClick={() => DeleteItem(record?.id, record?.name)} />
        </>
      ),
    },
  ];

  return (
    <>
      <PackagingModal
        openPackaging={openPackaging}
        setOpenPackaging={setOpenPackaging}
        id={selectedItemId}
        isPacking={isPacking}
        ItemsMutation={ItemsMutation}
        filter={filter}
        search={search}
        setPaginatedItems={setPaginatedItems}
        loadingcategory={loadingcategory}
        formatedcategory={formatedcategory}
        formatedItemUnit={formatedItemUnit}
        loadingItemUnit={loadingItemUnit}
        formatedBrand={formatedBrand}
        loadingBrand={loadingBrand}
        formatedSupplier={formatedSupplier}
        loadingSupplier={loadingSupplier}
        formatedPriceScheme={formatedPriceScheme}
        loadingPriceScheme={loadingPriceScheme}
        page={page}
      />
      <ComponentModal
        openComponent={openComponent}
        setOpenComponent={setOpenComponent}
        id={selectedItemId}
        isComposed={isComposed}
        ItemsMutation={ItemsMutation}
        filter={filter}
        search={search}
        setPaginatedItems={setPaginatedItems}
        loadingcategory={loadingcategory}
        formatedcategory={formatedcategory}
        formatedItemUnit={formatedItemUnit}
        loadingItemUnit={loadingItemUnit}
        formatedBrand={formatedBrand}
        loadingBrand={loadingBrand}
        formatedSupplier={formatedSupplier}
        loadingSupplier={loadingSupplier}
        formatedPriceScheme={formatedPriceScheme}
        loadingPriceScheme={loadingPriceScheme}
        page={page}
      />
      <Table
        key={tableKey}
        className="custom-table"
        columns={columns}
        dataSource={selectedCategory ? filteredItems : paginatedItems}
        scroll={{ x: 1000 }}
        loading={isItemsLoading}
        rowClassName={(record, index) =>
          index % 2 === 0
            ? "table-row-light table-row"
            : "table-row-dark table-row"
        }
        onChange={(selectedPage) => {
          setPrevPage(page);
          setPage(selectedPage?.current ?? 1);
        }}
        rowKey={(record) => record.id}
      />
      <DeleteModal
        open={open}
        setOpen={setOpen}
        name={nameToDelete}
        onOk={handleOk}
      />
    </>
  );
};

export default InventoryList;
